import React from "react";
import { useTranslation } from "react-i18next";
import type { SupportedLanguage } from "../../i18n";

const LANGUAGES: { code: SupportedLanguage; label: string }[] = [
  { code: "bg", label: "БГ" },
  { code: "en", label: "EN" },
];

export function LanguageSwitcher(): React.ReactElement {
  const { i18n } = useTranslation();

  return (
    <div className="inline-flex w-fit max-w-full items-center gap-0.5 self-start rounded-lg border border-navy/30 bg-white/50 p-0.5 shrink-0">
      {LANGUAGES.map(({ code, label }) => (
        <button
          key={code}
          type="button"
          onClick={() => i18n.changeLanguage(code)}
          className={`min-w-[2.25rem] flex-none rounded-md px-1.5 py-1 text-sm font-medium transition-colors ${
            i18n.language === code || i18n.language.startsWith(code)
              ? "bg-navy text-white"
              : "text-navy hover:bg-navy/10"
          }`}
          aria-pressed={i18n.language === code || i18n.language.startsWith(code)}
          aria-label={`Switch to ${label}`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default LanguageSwitcher;
